import React, { useRef, useState } from "react";
import AddButton from "../../buttons/button";
import ItemsInputField from "../../forms/items-input-field";
import ItemsSelectField from "../../forms/items-select-field";
import UploadIcon from "../../../assets/icons/upload-icon";
import ViewIcon from "../../../assets/icons/view-icon";
import { useFormikContext } from "formik";
import { ChevronUp, ChevronDown } from "lucide-react";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import { useNavigate } from "react-router-dom";
import TransSummaryComp from "../../helper-components/trans-summary-comp";

const AuditFooterSection = ({
  disabled,
  page = "create",
  submitLoading = false,
}) => {
  const { values, setFieldValue, errors, validateForm } = useFormikContext();

  const navigate = useNavigate();

  const auditSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[70px] w-[32%] p-3 flex justify-between",
      label: "Total Items",
      value: values?.total_items_count || 0,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-footer-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[70px] w-[32%] p-3 flex justify-between",
      label: "Matching",
      value: values?.total_matched_item || 0,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--success-color)]",
      valueClass:
        "text-[length:var(--trans-stats-con-footer-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },

    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[70px] w-[32%] p-3 flex justify-between",
      label: "Mismatched",
      value: values?.total_miss_matched_item || 0,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--error-color)]",
      valueClass:
        "text-[length:var(--trans-stats-con-footer-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];
  const valueSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[70px] w-[32%] p-3 flex justify-between",
      label: "Added Value ",
      value: ` ₹${values?.total_added_item_value || 0}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--success-color)]",
      valueClass:
        "text-[length:var(--trans-stats-con-footer-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[70px] w-[32%] p-3 flex justify-between",
      label: "Removed Value",
      value: ` ₹${values?.total_removed_item_value || 0}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--error-color)]",
      valueClass:
        "text-[length:var(--trans-stats-con-footer-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[70px] w-[32%] p-3 flex justify-between",
      label: "Net Difference",
      value: ` ₹${values?.total_item_net_difference || 0}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-footer-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  return (
    <div className="h-[13rem] flex flex-col ">
      <div className="h-[8rem]  mx-5  my-[0.5rem] border border-[var(--create-table-main-border)] border-1 border-radius p-4 flex justify-between">
        <div className="w-[49%]">
          <h2
            className=" text-[var(--create-table-footer-heading-fg)] 
                 text-[length:var(--create-table-footer-heading-fs)] 
                 font-[var(--create-table-footer-heading-fw)] "
          >
            Audit Summary{" "}
          </h2>

          <div className="flex justify-between mt-[0.8rem]">
            {auditSummary?.map((audit) => (
              <TransSummaryComp sum={audit} />
            ))}
          </div>
        </div>
        <div className="w-[49%]">
          <h2
            className=" text-[var(--create-table-footer-heading-fg)] 
                 text-[length:var(--create-table-footer-heading-fs)] 
                 font-[var(--create-table-footer-heading-fw)] "
          >
            Value Differences
          </h2>
          <div className="flex justify-between mt-[0.8rem]">
            {valueSummary?.map((audit) => (
              <TransSummaryComp sum={audit} />
            ))}
          </div>
        </div>
      </div>

      <div className="h-[4rem] flex justify-between px-5 border-t border-[var(--create-table-footer-border)]">
        <div></div>
        <div className="flex gap-3 items-center">
          {!disabled && (
            <>
              <AddButton
                prefixIcon={false}
                text={"Draft"}
                className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--draft-button-bg)] cursor-pointer
text-[var(--draft-button-fg)]
border border-[var(--draft-button-border)]
text-[length:var(--draft-button-fs)] 
font-[var(--draft-button-fw)]
"
                type="submit"
                onclkFn={() => {
                  setFieldValue("submittedButton", "draft");
                  if (Object.keys(errors).length > 0) {
                    handleShowErrorToast(errors);
                  }
                }}
              />
              <AddButton
                loading={submitLoading}
                prefixIcon={false}
                text={"Submit Audit"}
                className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)] 
font-[var(--primary-button-font-weight)]
"
                type="submit"
                onclkFn={async () => {
                  setFieldValue("submittedButton", "submit");

                  const formErrors = await validateForm();
                  if (Object.keys(formErrors).length > 0) {
                    handleShowErrorToast(formErrors);
                  }
                }}
              />
            </>
          )}

          {disabled && values?.is_stock_draft && (
            <AddButton
              prefixIcon={false}
              text={"EDIT"}
              className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-font-size)] 
font-[var(--primary-button-font-weight)]
"
              type="button"
              onclkFn={() => {
                navigate(`/edit-audit/${values?.sat_id}`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditFooterSection;
